import { render } from "./TitleModal.vue?vue&type=template&id=c18f5b98"
import script from "./TitleModal.vue?vue&type=script&lang=js"
export * from "./TitleModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__